import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const galleryImages = [
  {
    url: 'https://customer-assets.emergentagent.com/job_ruis-steakhouse/artifacts/cb4xwori_WhatsApp%20Image%202026-04-24%20at%2000.36.39%20%281%29.jpeg',
    alt: { en: 'Outdoor terrace in the evening', pt: 'Esplanada à noite' }
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_ruis-steakhouse/artifacts/pyo905q8_WhatsApp%20Image%202026-04-17%20at%2012.21.49.jpeg',
    alt: { en: 'Steak with fries', pt: 'Bife com batatas fritas' }
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_ruis-steakhouse/artifacts/cd1d80a3_WhatsApp%20Image%202026-04-17%20at%2012.21.51.jpeg',
    alt: { en: 'Busy restaurant night', pt: 'Noite movimentada no restaurante' }
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_ruis-steakhouse/artifacts/hp2qtrai_WhatsApp%20Image%202026-04-17%20at%2012.21.49%20%282%29.jpeg',
    alt: { en: 'Lamb chops with chimichurri', pt: 'Costeletas de borrego com chimichurri' }
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_ruis-steakhouse/artifacts/0blq05ul_WhatsApp%20Image%202026-04-17%20at%2012.21.52%20%281%29.jpeg',
    alt: { en: 'Restaurant exterior at night', pt: 'Exterior do restaurante à noite' }
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_ruis-steakhouse/artifacts/ala6j6z6_rui%201.jpg',
    alt: { en: 'Grilled steak with vegetables', pt: 'Bife grelhado com legumes' }
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_ruis-steakhouse/artifacts/awbtxwyh_WhatsApp%20Image%202026-04-17%20at%2012.21.52%20%282%29.jpeg',
    alt: { en: 'Cozy dining area', pt: 'Área de jantar acolhedora' }
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_ruis-steakhouse/artifacts/6ipvd03w_WhatsApp%20Image%202026-04-17%20at%2012.21.50.jpeg',
    alt: { en: 'Two steaks on slate', pt: 'Dois bifes na ardósia' }
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_ruis-steakhouse/artifacts/bmzkzjbq_rui4.jpg',
    alt: { en: 'Outdoor terrace dining', pt: 'Esplanada ao ar livre' }
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_ruis-steakhouse/artifacts/37q7rn4i_WhatsApp%20Image%202026-04-17%20at%2012.21.51%20%281%29.jpeg',
    alt: { en: 'Braised lamb with vegetables', pt: 'Borrego estufado com legumes' }
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_ruis-steakhouse/artifacts/2c009mmj_WhatsApp%20Image%202026-04-17%20at%2012.21.52%20%283%29.jpeg',
    alt: { en: 'Restaurant interior', pt: 'Interior do restaurante' }
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_ruis-steakhouse/artifacts/7aqepkza_WhatsApp%20Image%202026-04-17%20at%2012.21.51%20%282%29.jpeg',
    alt: { en: 'Garlic shrimp', pt: 'Camarões com alho' }
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_ruis-steakhouse/artifacts/fj8tlzxn_Rui7.jpg',
    alt: { en: 'Delicious dessert', pt: 'Sobremesa deliciosa' }
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_ruis-steakhouse/artifacts/ta1ybyaf_WhatsApp%20Image%202026-04-17%20at%2012.21.52.jpeg',
    alt: { en: 'Restaurant sign', pt: 'Placa do restaurante' }
  },
];

export default function GallerySection() {
  const { language, t } = useLanguage();

  return (
    <section
      data-testid="gallery-section"
      className="section-padding bg-[#F0EAE1]"
    >
      <div className="section-container">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="overline mb-4">{t('gallery.overline')}</p>
          <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-medium text-[#2A1E17]">
            {t('gallery.title')}
          </h2>
          <div className="w-20 h-[2px] bg-[#8C5A2B] mx-auto mt-6" />
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
          {galleryImages.map((image, index) => (
            <div
              key={index}
              data-testid={`gallery-image-${index}`}
              className={`relative overflow-hidden group ${
                index === 0 ? 'col-span-2 row-span-2' : ''
              }`}
            >
              <img
                src={image.url}
                alt={image.alt[language]}
                className={`w-full object-cover transition-transform duration-700 group-hover:scale-110 ${
                  index === 0 ? 'h-[400px] md:h-[500px]' : 'h-[200px] md:h-[240px]'
                }`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#2A1E17]/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
